module.exports = __webpack_public_path__ + "media/images/flags/ma-363a4f79da72a6e74be0d7f8d4e6c1dc.svg";